export default __webpack_public_path__ + "static/media/aiCameraButton.2a2841bd.svg";